import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export type ChatMessage = {
  role: string;
  content: string;
  partial?: boolean;
  id?: string;
};


// 1. Define the base styles and variants, now using tw-animate-css
const chatMessageVariants = cva(
  // Base classes applied to all messages
  // We replaced 'opacity-0 animate-fade-in' with the line below
 'my-3 max-w-[95%] rounded-[3em] px-8 py-6 text-base shadow-message select-text transition-opacity ease-in-out animate-in fade-in slide-in-from-bottom-4 duration-500 break-words',
  {
    variants: {
      variant: {
        user: 'self-end bg-user-message-bg text-right text-user-message-text',
        assistant: 'self-start bg-ai-message-bg text-left text-ai-message-text',
      },
    },
    defaultVariants: {
      variant: 'assistant',
    },
  }
);

// ... The rest of the component remains exactly the same ...
export interface DEAIChatMessageProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof chatMessageVariants> {
  isFaded?: boolean;
}

const DEAIChatMessage = React.forwardRef<HTMLDivElement, DEAIChatMessageProps>(
  ({ className, variant, isFaded, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
            chatMessageVariants({ variant }),
            {
              'opacity-0 duration-[3000ms]': isFaded,
            },
            className
          )}
        {...props}
      />
    );
  }
);

export { DEAIChatMessage, chatMessageVariants };